import styled from "styled-components";

export const Container = styled.div`
  max-width: 1000px;
  margin: 0 auto;

  /* background-color: red; */
`;

export const SingleCard = styled.div`
  display: flex;
  align-items: center;
  padding: 15px;
  background-color: #f5f4f1;
  border: 0.1px solid #38041d;
  border-radius: 20px;
  margin: 1em 0;
  &:last-child {
    display: none;
  }
  /* flex-wrap: wrap; */
  /* box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2); */
  /* &:nth-child(odd) {
    flex-direction: row-reverse;
    background-color: red;
  } */
  @media (max-width: 768px) {
    flex-direction: column-reverse;
    text-align: center;
    /* gap: 1rem; */
    /* &:nth-child(odd) {
      flex-direction: column;
    } */
  }
`;

export const IconContainer = styled.div`
  flex: 1 0 auto;
  display: flex;
  position: relative;

  img {
    /* background-color: green; */
    transform: translateY(10px);
    opacity: 0;
    transition: opacity 0.5s ease, transform 0.5s ease;
    border-right: 0.1px solid #38041d;
    padding: 25px;

    &.visible {
      opacity: 1;
      transform: translateY(0);
    }

    width: 10em;
    height: auto;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const Description = styled.p`
  align-self: center;
  padding: 10px;

  /* width: 10%; */

  ul {
    list-style: none;
    /* margin-top: 1rem; */
    padding-left: 10px;
  }

  li {
    padding: 0.4rem 0;
    display: flex;
    align-items: center;
    text-align: start;
    text-transform: capitalize;
    /* font-size: 1.1rem; */
    font-size: clamp(14px, 1vw, 3em);
    svg {
      /* background-color: green; */
    }
  }

  li span {
    /* margin-left: 10px; */
    align-self: center;
    color: #333;
    font-weight: bold;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  /* background-color: red; */

  p {
    text-align: center;
    font-size: clamp(14px, 1vw, 3em);
  }

  @media (max-width: 576px) {
    /* order: 1; */
  }
`;

export const Title = styled.h2`
  /* flex: 0 1 auto; */
  font-size: 24px;
  text-align: center;
  /* color: #1f3d2b; */
  /* margin: 0; */
  font-weight: bold;
  .subtitle {
    font-weight: normal;
    /* font-style: italic; */
    font-size: 18px;
  }
`;
